export default __webpack_public_path__ + "static/media/lorem2.d91d0a40.svg";